import React from 'react';
import Skeleton from 'react-loading-skeleton';

function UpdateCustomContactSkeleton() {
  return (
    <div className={`account-list px-0 pb-2 update-custom-contact-body`}>
      <div className='pr-3' id='settings-container'>
        <ul className='policy-list px-0 hover-content'>
          <form className='mx-0'>
            <div className='px-0'>
              <li className='add-contact-list-item'>
                <Skeleton height={17} width={80} />
                <div className='pl-2 mt-2 account-email-field'>
                  <input type='text' name='firstName' required />
                </div>
              </li>
              <li className='add-contact-list-item'>
                <Skeleton height={17} width={80} />
                <div className='pl-2 mt-2 account-email-field'>
                  <input type='text' name='lastName' required />
                </div>
              </li>
              <li>
                <Skeleton height={17} width={120} />
                <div className='pl-2 mt-2 account-email-field'>
                  <input type='text' required name='email' />
                </div>
              </li>
              <li>
                <Skeleton height={17} width={70} />
                <div className='pl-2 mt-2 account-email-field'>
                  <input type='text' required name='salutation' />
                </div>
              </li>
              <li>
                <Skeleton height={17} width={90} />
                <div className='pl-2 mt-2 account-email-field'>
                  <textarea type='text' style={{ overflow: 'hidden', resize: 'none' }} name='description' />
                </div>
              </li>
            </div>
          </form>
        </ul>
      </div>
    </div>
  );
}

export default UpdateCustomContactSkeleton;
